<script>
export default {
  name: "GoalsBase",
  methods: {
    timeframeColor(timeframe) {
      let color = "green";
      switch (timeframe) {
        case "BHAG":
          break;
        default:
          color += " lighten-2";
      }

      return color;
    },
    statusColor(status) {
      status = status.toLowerCase();
      status.replace("_", " ");
      let color = "green";
      switch (status) {
        case "achieved":
          color = "pink lighten-2";
          break;
        case "closed":
          color = "grey lighten-2";
          break;
        case "not achieved":
          color = "grey darken-2";
          break;
        case "in progress":
          color = "green lighten-2";
          break;
        default:
          color += " lighten-2";
      }

      return color;
    },
    displayTimeframe(timeframe) {
      return timeframe.replace("CHECKIN", "CHECK-IN");
    },
  },
};
</script>
